import { ApiClient } from '@/shared/api/client';
import type { AiUsageResponse } from './types';

export interface AiUsageQuery {
  from: string;
  to: string;
  userId?: string;
  provider?: string;
  status?: string;
  page: number;
  size: number;
}

export class AiUsageApi {
  static fetch(query: AiUsageQuery): Promise<AiUsageResponse> {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => { if (value) params.set(key, String(value)); });
    return ApiClient.getJson<AiUsageResponse>(`/ai-usage/events?${params.toString()}`);
  }
}
